import { Component, OnInit } from '@angular/core';
import { FunctionsService } from 'src/app/_LOGIC/__common/functions.service';

@Component({
  selector: 'app-package-offer',
  templateUrl: './package-offer.component.html',
  styleUrls: ['./package-offer.component.css']
})
export class PackageOfferComponent implements OnInit {

  constructor(private commonFunctions: FunctionsService) { }

  ngOnInit(): void {
  }

  goToCalendly(){
    this.commonFunctions.goToCalendly();
  }

}
